//获取 cookie 值的函数
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) 
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}

var x = getCookie("distributor");

if (x !== "") {
var paragraph3 = document.querySelector('.nav-search');
 
paragraph3.style.display = "none";
}